import CardServicos from "./cardServicos";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "./carousel";
import Container from "./container";
import AccordionServicos from "./accordionServicos";
import OtimizeSeuNegocio from "./OtimizeSeuNegocio";
import { useState } from "react";

export default function MigracaoBeneficios({ servicosData, title }) {
  const [openAccordionId, setOpenAccordionId] = useState(null);
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const [expandedMobileIndex, setExpandedMobileIndex] = useState(null);
  
  // Handle accordion toggle in mobile view
  const handleAccordionToggle = (index, isOpen) => {
    if (isOpen) {
      // Close any previously opened accordion
      if (expandedMobileIndex !== null && expandedMobileIndex !== index) {
        // Find the previously opened accordion and close it
        const prevAccordion = document.querySelector(`[data-accordion-index="${expandedMobileIndex}"]`);
        if (prevAccordion) {
          prevAccordion.click();
        }
      }
      setExpandedMobileIndex(index);
      setOpenAccordionId(servicosData[index].id);
    } else if (expandedMobileIndex === index) {
      setExpandedMobileIndex(null);
      setOpenAccordionId(null);
    }
  }

  return (
    <div className="w-full bg-[rgb(24,14,81)] bg-[url(../assets/beneficios-finops-mobile.png)] md:bg-[url(../assets/cover-migracao-beneficios.png)] bg-cover bg-top py-20 relative overflow-hidden text-white">
      <Container className="relative z-10">
        <h2 className="font-inter-regular text-2xl md:text-[60px] text-center mb-12">
          {title}
        </h2>
        <div className="relative mx-[-1rem] md:mx-[-2rem] hidden md:block">
        <Carousel className="overflow-visible">
            <div className="flex justify-end absolute right-8 md:right-12 top-6 z-10">
              <CarouselPrevious className="h-8 w-8 rounded-full bg-transparent hover:cursor-pointer hover:scale-130 transition-transform duration-300" />
              <CarouselNext className="h-8 w-8 rounded-full bg-transparent hover:cursor-pointer hover:scale-130 transition-transform duration-300" />
            </div>
            <CarouselContent className="p-8">
              {servicosData.map((servico, index) => (
                <CarouselItem key={index} className="basis-full sm:basis-1/2 md:basis-1/3 lg:basis-1/3 pl-4 md:pl-6">
                  <div className="relative overflow-visible px-2">
                    <div 
                      className="relative h-[350px] mb-8" 
                      onMouseEnter={() => setHoveredIndex(index)}
                      onMouseLeave={() => setHoveredIndex(null)}
                    >
                      <CardServicos {...servico} height={"350"} className="hidden md:block" />
                      
                      {/* OtimizeSeuNegocio component that appears on hover */}
                      <div 
                        className={`hidden md:block absolute left-0 right-0 bottom-[-90px] transition-all duration-300 ${hoveredIndex === index ? 'opacity-100 visible' : 'opacity-0 invisible'}`}
                      >
                        <OtimizeSeuNegocio 
                          text="Otimize seu negócio!"
                          buttonText="Contratar"
                          useFormularioRD={true}
                          type="gradient"
                          className="w-full"
                        />
                      </div>
                    </div>
                  </div>
                </CarouselItem>
              ))}
            </CarouselContent>
          </Carousel>
        </div>

        <div className="md:hidden space-y-4">
          {servicosData.map((servico, index) => (
            <div key={index} className="relative">
              <AccordionServicos
                key={`mobile-${index}`}
                {...servico}
                doesThereButton={false}
                className="bg-[rgb(36,29,73)] backdrop-blur-[92px] text-left"
                onToggle={(isOpen) => handleAccordionToggle(index, isOpen)}
                accordionIndex={index}
              />
              
              {/* Mobile OtimizeSeuNegocio that appears when accordion is expanded */}
              <div 
                className={`transition-all duration-300 ease-in-out transform w-full overflow-hidden
                  ${expandedMobileIndex === index ? 'max-h-[100px] opacity-100' : 'max-h-0 opacity-0'}`}
                style={{
                  transitionProperty: 'max-height, opacity, transform',
                  transform: expandedMobileIndex === index ? 'translateY(0)' : 'translateY(-10px)',
                  zIndex: 20,
                  position: 'relative'
                }}
              >
                <OtimizeSeuNegocio 
                  text="Otimize seu negócio!"
                  buttonText="Contratar"
                  useFormularioRD={true}
                  type="gradient"
                  className="w-full mt-4"
                />
              </div>
            </div>
          ))}
        </div>
      </Container>
    </div>
  );
}
